import {useAppDispatch} from "../../../hooks/hooks";
import {useCallback} from "react";
import {updateCouponCodeStatusAsync} from "../../../store/couponCodeSlice";

export function useCouponCodeStatusUpdater() {
    const dispatch = useAppDispatch();

    // 쿠폰코드 상태 변경
    const updateCouponCodeStatus = useCallback(
        async (idx: number) => {
            try {
                await dispatch(updateCouponCodeStatusAsync(idx)).unwrap();
                alert('쿠폰 코드 상태가 변경되었습니다.')
            } catch
                (e) {
                alert('일시적인 문제가 발생했습니다.\n다시 시도해주세요.')
            }
        }, [dispatch]);

    return {
        updateCouponCodeStatus,

    }
}